// @ts-nocheck
// todo : remove when the new auth is merged in
import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_LOCALE } from '@skytech/utils'

import messages_en from '@/translations/en.json'
import messages_no from '@/translations/no.json'

export const NAME = 'intl'

export const messages = {
  no: messages_no,
  en: { ...messages_no, ...messages_en },
}

const checkLocale = locale => (messages[locale] ? locale : DEFAULT_LOCALE)

const browserLanguage = navigator.language.split(/[-_]/)[0]
const locale = checkLocale(browserLanguage)

const initialState = {
  locale,
  messages: messages[locale],
  allMessages: { ...messages },
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setMessages: (state, { payload: allMessages }) => {
      state.allMessages = allMessages
      state.messages = allMessages[state.locale]
    },
    setLocale: (state, { payload: locale }) => {
      state.locale = locale
      state.messages = state.allMessages[locale]
    },
  },
})

export const { setMessages, setLocale } = actions

const getState = state => state[NAME]

export const getLocale = state => getState(state).locale
export const getMessages = state => getState(state).messages || {}
export const getMessage = (state, code) => getMessages(state)[code.toLowerCase()]

export default reducer
